module.exports = __webpack_public_path__ + "media/images/travel-ff5940b5e5df0d9a121e646732108a3e.png";